import React from 'react';
import {useTranslation} from 'react-i18next';
import * as defaultCss from './SearchLine.css';

interface CustomCssProps {
    container: React.ComponentType<any>;
    input: React.ComponentType<any>;
}

interface SearchLineProps {
    filter: string;
    setFilter: (value: string) => void;
    action?: (filter: string) => void;
    title?: string;
    customCss?: CustomCssProps;
}

function SearchLine({filter, setFilter, action, title, customCss}: SearchLineProps) {
    const {t} = useTranslation('global');
    
    const css = customCss || defaultCss;

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.stopPropagation();
        setFilter(e.target.value);
        if(action){
            action(filter);
        }
    };

    return (
        <>
            <css.container onClick={(e: React.MouseEvent) => e.stopPropagation()} >
                <css.input value={filter} autoFocus autoComplete="off" name='search' placeholder={title || t('searchPlaceHolder')} onChange={onChange} />
            </css.container>
        </>
    );
}

export default SearchLine;
